import styled from '@emotion/styled'
import {COLORS} from '../constants'

/** Vertical stack holding the view title and its one-line explanation. */
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

/** The view's name — "Master Money Manager Tree" or "My Downline Network". */
export const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: ${COLORS.foreground};
`

/** One line saying what the active view includes, and (for the agent view) what it leaves out. */
export const Description = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${COLORS.mutedText};
`
